<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 18:15:08
 * @LastEditTime: 2021-01-22 14:28:15
 * @LastEditors: daikeyi
 -->
<template>
    <div id="page_Container" class="login-page">
        <div class="page">
            <div id="main-container" class="main-container">
                <div class="form-zone">
                    <div class="form-zone-inner" id="forminput">
                        <van-cell-group>
                            <van-field type='tel' v-model="ruleForm.phonenum" placeholder="请输入手机号码">
                                <template slot="left-icon">
                                    <img  class="loginmobileimg" :src="loginmobile" alt="">
                                </template>
                                <van-button slot="button" size="small" class="send-btn"  v-bind:class="{sended:!codeButton}" type="primary" id="btn" @click="handleCode"  :disabled="!codeButton">{{codeMsg}}</van-button>
                            </van-field>
                            <van-field maxlength="4" v-model="ruleForm.verificode" placeholder="请输入验证码">
                                <template  slot="left-icon">
                                    <img :src="logincode" alt="">
                                </template>
                            </van-field>
                        </van-cell-group>
                    </div>
                    <div class="login-btn">
                        <van-button size="large" type="primary" :disabled="btndisabled" round @click="handleSubmit">登录</van-button>
                    </div>
                </div>
                <div class="gohome-bar" @click="gohome">
                    <img src="../assets/img/home/downtab/home1.png" alt="">
                    <span class="word">商城首页</span>
                </div>
            </div>
         </div>
    </div>
</template>
<script>
import { Toast } from 'vant';
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'login',
    data() {
        return {
            show: false,
            ruleForm: {
                phonenum: '',
                verificode: ''
            },
            loginmobile: require('../assets/img/common/loginmobile.png'),
            logincode: require('../assets/img/common/logincode.png'),
            codeButton: true, // 发送验证码按钮 是否禁用
            codeMsg: '获取验证码',
            codeTime: 60,
            btndisabled: true
        };
    },
    esvReady: function() {
        document.title = '登录';
    },
    methods: {
        ...mapActions([
            'esvcp/setOpId',
            'esvcp/setSysUserId'
        ]),
        timeCount() {
            var self = this;
            self.codeButton = false;
            self.codeTime--;
            self.codeMsg = self.codeTime + 's后重新发送';
            self.timeDao = setInterval(function() {
                if (self.codeTime < 1) {
                    self.codeButton = true;
                    self.codeMsg = '重新发送';
                    clearInterval(self.timeDao);
                    self.codeTime = 60;
                } else {
                    self.codeTime--;
                    self.codeMsg = self.codeTime + 's后重新发送';
                }
            }, 1000);
        },
        // 发送验证码
        handleCode() {
            const self = this;
            self.codeButton = false;
            self.$toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true // 禁用背景点击
            });
            const phone = this.ruleForm.phonenum;
            if ((/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(phone))) {
                self.$doRequest({
                    url: '/user/smsSend',
                    params: {
                        mobileNumber: this.ruleForm.phonenum.trim()
                    },
                    complete: function () {
                        self.codeButton = true;
                        self.$toast.clear();
                    }
                },
                function (data) {
                    if (data.responseCode === '100000') {
                        Toast('短信验证码发送成功');
                        self.timeCount();
                    } else {
                        Toast(data.message);
                    }
                });
            } else {
                self.$toast.clear();
                self.codeButton = true;
                if (phone.length === 0) {
                    Toast('请填写手机号码');
                } else {
                    Toast('手机号码格式不正确');
                }
            }
        },
        // 点击进入登录界面
        handleSubmit() {
            const self = this;
            self.$toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true // 禁用背景点击
            });
            const phone = this.ruleForm.phonenum;
            if ((/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(phone))) {
                self.$doRequest({
                    url: '/user/login',
                    params: {
                        mobileNumber: this.ruleForm.phonenum,
                        validateCode: this.ruleForm.verificode
                    },
                    complete: function () {
                        self.$toast.clear();
                    }
                },
                function (data) {
                    if (data.responseCode === '100000') {
                        Toast.success('登录成功');
                        self.queryMemberAccountDetail();
                        const accountNo = data.result.accountNo;
                        self['esvcp/setOpId'](accountNo);
                        self['esvcp/setSysUserId'](accountNo);
                        self.ESVStorage.putSavedValue('accountNo', accountNo);
                    } else {
                        Toast.fail(data.msg);
                    }
                });
            } else {
                Toast('手机号码格式不正确');
                self.$toast.clear();
            }
        },
        // 请求详情存入local
        queryMemberAccountDetail() {
            const ths = this;
            ths.$doRequest({
                url: '/account/queryMemberAccountDetail',
                params: {
                    merchantInfo: JSON.stringify(this.merchantInfoSwitch)
                }
            },
            (data) => {
                ths.ESVStorage.putSavedValue(
                    'accountDetail',
                    data.result);
                // debugger;
                this.esvBackPage(1);
                // window.history.go(-1);
            }
            );
        },
        gohome() {
            const ths = this;
            ths.esvReloadPage('OPHomenew');
        }
    },
    computed: {
        ...mapGetters(['merchantInfoSwitch']),
        verificode() {
            return this.ruleForm.verificode;
        }
    },
    watch: {
        verificode(curVal, oldVal) {
            if (curVal && curVal.length >= 4) {
                this.btndisabled = false;
            } else {
                this.btndisabled = true;
            }
        }
    }
};
</script>
<style  lang="scss" scoped>
.login-page {
    position: relative;
    font-size: 14px;
    .form-zone {
        margin-top: 12px;
        position: relative;
        .form-zone-inner {
            background: #ffffff;
            position: relative;
            z-index: 10;
            box-shadow: 0 0 8px 0 rgba(105, 135, 163, 0.17);
            img{
                width: 16px;
                height: 20px;
                margin-right: 16px;
                vertical-align: middle;
            }
            .loginmobileimg{
                margin-top: 4px;
            }
            .send-btn {
                border: none;
                border-radius: 0;
                background: white;
                color: $primary-color;
                font-size: 14px;
            }
            .sended{
                color: #999;
            }
        }
        .login-btn {
            margin: 24px 24px 0;
        }
    }
    .gohome-bar{
        margin: auto;
        text-align: center;
        position: fixed;
        bottom: 16px;
        left: 0;
        width: 100%;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #EE2E50;
        img{
            height: 16px;
            vertical-align: middle;
        }
        .word{
            padding: 0;
            text-decoration: underline;
        }
    }
}
[class*='van-hairline']:last-child::after {
    border: none;
}

.van-cell {
    padding:15px 10px;
    -ms-line-height: 50px;
}
#forminput .van-field__control{
    padding: 10px 0;
    font-size: 14px;
}

</style>
